/**
 * Database Configuration
 * Cấu hình database backend cho ứng dụng
 */

import { normalizeVatliUrl } from '../utils/urlNormalizer';

export type DatabaseBackend = 'wordpress' | 'sqlite' | 'localstorage';

interface DatabaseConfig {
  backend: DatabaseBackend;
  wordpressApiUrl?: string;
  productionDomain?: string;
}

// ✅ Production domain configuration
// WordPress được cài trên DOMAIN CHÍNH, không phải subdomain
const WORDPRESS_DOMAIN = 'https://vatli365.vn';  // ← Domain chính (WordPress + API)
const REACT_APP_DOMAIN = 'https://ebook.vatli365.vn';  // ← Subdomain (React app only)
const WORDPRESS_API_PATH = '/wp-json/qoder/v1';
const DEFAULT_WORDPRESS_API_URL = `${WORDPRESS_DOMAIN}${WORDPRESS_API_PATH}`;
const ENV_WORDPRESS_API_URL = import.meta.env.VITE_WP_API_URL;
const NORMALIZED_WORDPRESS_API_URL = normalizeVatliUrl(
  ENV_WORDPRESS_API_URL,
  DEFAULT_WORDPRESS_API_URL
);

// ✅ Cấu hình database backend
export const databaseConfig: DatabaseConfig = {
  // Chọn backend: 'wordpress' | 'sqlite' | 'localstorage'
  // ⚠️ QUAN TRỌNG: Luôn dùng 'wordpress' để test nhất quán giữa dev và production
  // Nếu muốn test localStorage, set VITE_DB_BACKEND=sqlite
  backend: (import.meta.env.VITE_DB_BACKEND as DatabaseBackend) || 'wordpress',
  
  // Production domain (WordPress)
  productionDomain: WORDPRESS_DOMAIN,
  
  // WordPress API URL
  // ⚠️ CẢ DEV VÀ PRODUCTION ĐỀU GỌI VỀ PRODUCTION WORDPRESS API
  // Điều này đảm bảo dev local test được auth, CORS, database thực tế
  wordpressApiUrl: NORMALIZED_WORDPRESS_API_URL,
};

console.log('📊 Database Config:', {
  backend: databaseConfig.backend,
  apiUrl: databaseConfig.wordpressApiUrl,
  domain: databaseConfig.productionDomain,
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
});

export default databaseConfig;

